import axios from "axios";

const address = process.env.NEXT_PUBLIC_API_URL;

export const createEraseAndReplace = (obj, token) => {
	let headers = { "Content-Type": "application/form-data" };

	if (token) {
		headers = { "Content-Type": "application/form-data", Authorization: `Bearer ${token}` };
	}

	let formData = new FormData();

	for (let key in obj) {
		formData.append(key, obj[key]);
	}

	return axios.post(`${address}/v1/text2image/tasks/`, formData, { headers: headers });
};

export const getEraseAndReplaceTaskStatus = (task_id) => {
	return axios.get(`${address}/v1/text2image/tasks/${task_id}/`);
};

export const createExtendImage = (obj, token) => {
	let headers = { "Content-Type": "application/form-data" };

	if (token) {
		headers = { "Content-Type": "application/form-data", Authorization: `Bearer ${token}` };
	}

	let formData = new FormData();

	for (let key in obj) {
		formData.append(key, obj[key]);
	}

	return axios.post(`${address}/v1/text2image/jobs/`, formData, { headers: headers });
};

export const getExtendImageTaskStatus = (job_id) => {
	return axios.get(`${address}/v1/text2image/jobs/${job_id}/`);
};

export const getEraseAndReplaceResult = (task_id, originalWidth, originalHeight, token) => {
	let headers = { "Content-Type": "multipart/form-data" };

	if (token) {
		headers = {
			Authorization: `Bearer ${token}`,
		};
	}
	let formData = new FormData();
	formData.append("width", originalWidth);
	formData.append("height", originalHeight);
	return axios.post(`${address}/v1/text2image/tasks/${task_id}/download/`, formData, {
		headers: headers,
	});
};
